import { React, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "../main-page.css";
import Button from "react-bootstrap/Button";
import { Row, Col, Offcanvas } from "react-bootstrap";
import { FaLongArrowAltRight } from "react-icons/fa";
import NavDropdown from "react-bootstrap/NavDropdown";
import { CgMenuGridO } from "react-icons/cg";
import { RiGalleryLine } from "react-icons/ri";
import { FaChartArea } from "react-icons/fa";
import { GrStatusUnknown } from "react-icons/gr";
import Carousel from "react-bootstrap/Carousel";
import NewsTicker from "./newsticker";
import SliderWithImages from "./vegas";
import { TiSocialFacebook } from "react-icons/ti";
import { FaTwitter } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
function DashBoard() {
  const [show, setShow] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };
  const [isPaused, setIsPaused] = useState(false);

  const handleMouseEnter1 = () => {
    setIsPaused(true);
  };

  const handleMouseLeave1 = () => {
    setIsPaused(false);
  };
  const newsItems = [
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
  ];




  const [showSide, setShowSide] = useState(false);
  const [showBottom, setShowBottom] = useState(false);

  const handleCloseSide = () => setShowSide(false);
  const handleShowSide = () => {
    setShowSide(true);
    setShowBottom(false); // Close the bottom Offcanvas when opening the side Offcanvas
  };

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = () => {
    setShowBottom(true);
    setShowSide(false); // Close the side Offcanvas when opening the bottom Offcanvas
  };


  const [smShow, setSmShow] = useState(false);
  const [lgShow, setLgShow] = useState(false);
 
  return (
    <>
       <Navbar expand="lg" className='main-navbar fixed-top'>
        <Container fluid className='p-0'>
          <Navbar.Brand href="#home" className='d-flex align-items-center'>
            <a class="navbar-brand  d-flex align-items-center ms-2 ms-md-4" href="#">
            <img src="../images/apslogo.webp" alt="aps" className="img-fluid" />
            <div className="brand-text ms-2 text-left">
              <p className="brand-title">AndhraPradesh State<br></br><span>Housing</span> Corporation Limited</p>
            </div>
          <img src="../images/aplogo.webp" alt="Logo" className="img-fluid" />
          </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"  className="border-0"/>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link className='' href="/">Home</Nav.Link>
              <Nav.Link className='' href="/about">About</Nav.Link>
              <Nav.Link className='active' href="/DashBoard">Dashboard</Nav.Link>
              <Nav.Link className='' href="/organogram">Organogram</Nav.Link>
              <Nav.Link className='' href="/donation">Donation</Nav.Link>
              <Nav.Link className='' href="/contact">Contact Us</Nav.Link>
            </Nav>
                <Button onClick={handleShow} className="menu-btn"><CgMenuGridO style={{ fontSize: '35px' }} />
                </Button>
                <Offcanvas show={show} onHide={handleClose} placement="end" className='main-off'>
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title></Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav defaultActiveKey="/home" className="side-nav">
                      <Nav.Link href="/home">Gallery</Nav.Link>
                      <Nav.Link href="/organogram"  eventKey="link-1">Organogram</Nav.Link>
                      <Nav.Link eventKey="link-2">Whos is who</Nav.Link>
                      <Nav.Link href="/contact" eventKey="link-2">Contact US</Nav.Link>
                    </Nav>
                  </Offcanvas.Body>
                </Offcanvas>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <SliderWithImages />
      {/* ================= Houses sanctioned================== */}
      {/* <Container fluid className="houses-sanctioned"> */}
      <Container  className="houses-sanctioned">
          <Row className="sanctioned-card">
            {/* ---------------firstline--------- */}
            {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src=" ../images/srikakulam.png" alt="" className="img-fluid"/>
                  </div>
                    <h3 className="departmentname">Srikakulam</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button   onClick={handleShowBottom}  type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
            
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/parvathi.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      {" "}
                      Parvathipuram Manyam
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/visaka.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      Visakhapatnam
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/vijayanagaram.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Vizianagaram</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/anakapalli.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Anakapalli</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/kakinada.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Kakinada</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
            {/* ---------------firstline--------- */}
            {/* ---------------secondline--------- */}
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/konasema.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Konaseema</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/alluriseetharama.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      Alluri Sitaramaraju
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/east.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      East Godavari
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/eluru.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname"> Eluru</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/ntr.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      {" "}
                      NTR District
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/guntoor.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Guntur</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
            {/* ---------------secondline--------- */}

            {/* ---------------thirdrow--------- */}
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/west.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      West Godavari
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/bapatla.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Bapatla</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/palnadu.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Palnadu</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/pottisri.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      Sri Potti Sriramulu Nellore
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/prakasam.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname"> Prakasam</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/tirupathi.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname"> Tirupati</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
            {/* ---------------fourthrow--------- */}

             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/annamayya.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Annamayya</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/ysrkadapa.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">YSR Kadapa</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/chittor.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Chittoor</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/ananthapur.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Anantpur</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/kurnool.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Kurnool</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/srisatya.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Sri Satyasai</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>    
            {/* ---------------fourthrow--------- */}
            {/* ---------------fifththrow--------- */}
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/nandyal.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">Nandyal</h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
             {/* <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}className="house-box my-2"> */}
            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}className="house-box my-2">
              <div class="newcard">
                <div className="logo-part">
                  <div className="corner-logo">
                    <img src="../images/srikakulam.png" alt="" className="img-fluid"/>
                  </div>
                  <h3 className="text-center departmentname">
                      Sri. Balaji Dist
                    </h3>
                </div>
                <div className="hover-text">
                <h1 class="count">12</h1>
                <p className="subbrand">Layout</p>
                <div className="morebtn-part">
                  <button   onClick={handleShowBottom} type="button" class="btn more-btn">MORE</button>
                </div>
                </div>
                <div className="text-center amount">
                <h4>23,654</h4>
                </div>
                <p className="central">Sanctioned</p>
              </div>
            </Col>
            {/* Button to show the side Offcanvas */}
      <Offcanvas show={showBottom} onHide={handleCloseBottom} placement="bottom" className=' bottomcanvas'>
        <Offcanvas.Header closeButton>
          
        </Offcanvas.Header>
        <Offcanvas.Body>
        <Row className="bottom-canvas">
        <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3 districtmap my-auto schemes ">
      <img src='../images/blueprint.webp' className="img-fluid blueprint-shape"/>
      <h2><span className="houseing-text"> Sri Potti Sriramulu Nellore</span></h2>
        </Col>
        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} className="mb-3">
        <Row>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <div className="card card-body shadow">
             <img src="../images/sanctioned.png" alt="" width={85} height={85} className="img-flui  m-auto d-block" />
              <div className="d-block d-md-flex justify-content-between border-top mt-2">
                <div className="fw-bold fs-5 mt-2">Sanctioned</div>
                <div className="fw-bold fs-3">54,258</div>
              </div>
             </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <div className="card card-body shadow">
             <img src="../images/completed.png" alt="" width={100} height={85} className="img-flui  m-auto d-block" />
              <div className="d-block d-md-flex justify-content-between border-top mt-2">
                <div className="fw-bold fs-5 mt-2">Completed</div>
                <div className="fw-bold fs-3">54,258</div>
              </div>
             </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <div className="card card-body shadow">
             <img src=" ../images/inprogress.png" alt="" width={85} height={85} className="img-flui  m-auto d-block" />
              <div className="d-block d-md-flex justify-content-between border-top mt-2">
                <div className="fw-bold fs-5 mt-2">Inprogress</div>
                <div className="fw-bold fs-3">54,258</div>
              </div>
             </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <div className="card card-body shadow">
             <img src=" ../images/expenditure.jpg" alt="" width={85} height={85} className="img-flui  m-auto d-block" />
              <div className="d-block d-md-flex justify-content-between border-top mt-2">
                <div className="fw-bold fs-5 mt-2">Expenditure</div>
                <div className="fw-bold fs-3">54,258</div>
              </div>
             </div>
            </Col>
            </Row>
            </Col>
          </Row>
        </Offcanvas.Body>
      </Offcanvas>
   {/* Button to show the bottom Offcanvas */}






            
            {/* ---------------fifththrow--------- */}
          </Row>
      </Container>
      {/* ================ Houses sanctioned=================== */}
      <footer className="pt-5 position-relative footer-part">
<img src="../images/blue-bottom-img.webp" className="img-fluid blue-bottom-img"/>  
<Container className="footer-contain">
 <Row>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3} className="mb-4 mb-md-0">
  <div className="footer-content">
   <h5>Address</h5>
   <p className="adsress-text">AP State Housing Corporation<br></br>Plot No : 11 & 12 Behind BSNL,<br></br>Telephone Exchange Auto Nagar,<br></br>Vijayawada, Andhra Pradesh- 520007.</p> 
  </div>
  <ul className="social-media-icons">
  <li><a href="#"><TiSocialFacebook className="icony"/></a></li>
  <li><a href="#"><FaTwitter className="icony"/></a></li>
  <li><a href="#"><FaGoogle className="icony"/></a></li>
  <li><a href="#"><FaYoutube className="icony"/></a></li>
  <li><a href="#"><FaInstagram className="icony"/></a></li>
</ul>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Important <span>Links</span></h5>
  <ul>
  <li><a href="#">PMAY-GRAMIN</a></li>  
  <li><a href="#">PMAY-URBAN</a></li>  
  <li><a href="#">Beneficiary Search</a></li>  
  <li><a href="#">OFMS</a></li>  
  <li><a href="#">Tenders</a></li>  
  <li><a href="#">RTI - Andhra Pradesh</a></li>  
  <li><a href="#">RTI - Government of India</a></li>  
  </ul>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Quick <span>Links</span></h5>
  <ul>
  <li><a href="#">Contact Us</a></li>  
  <li><a href="#">Gallery</a></li>  
  <li><a href="#">FAQ's</a></li>  
  <li><a href="#">News & Articles</a></li>  
  <li><a href="#">Signin / Login</a></li>  
  <li><a href="#">GO’s</a></li>  
  <li><a href="#">Circular's</a></li>  
  </ul>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Get in <span>Touch</span></h5>
  <div className="phone d-flex">
  <img src="../images/phone.webp" className="phone-img"/>
  <div className="phone-text">
  <h6>Toll free Number</h6>
  <p>08663501300</p>
  </div> 
  </div>
  <div className="email d-flex">
  <img src="../images/email.webp" className="email-img"/>
  <div className="email-text">
  <h6>Email ID</h6>
  <p>housing.ap@gmail.com</p>
  </div> 
  </div>
  <div className="location d-flex">
  <img src="../images/location.webp" className="location-img"/>
  <div className="location-text">
  <h6>Location</h6>
  <p>Vijayawada</p>
  </div> 
  </div>
  </div>
  </Col>
  </Row>
  <hr className="mb-0"></hr>
  <Row className="pt-4 pb-3">
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom">
    <p>All Rights Reserved © 2024, APSHCL</p>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom brand-text-bottom2">
    <p>Visitors Count : <span>850278</span></p>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom brand-text-bottom3">
    <p>Design and Developed by</p>
    <a href="https://apcfss.in/" target="_blank"><img src="../images/apcfss.webp" className="brand-logo"/></a>
  </div>
  </Col>
 </Row> 
</Container>  
</footer>
    </>
  );
}
export default DashBoard;
